module.exports = __webpack_public_path__ + "img/dictionary.cf52754e.jpg";